import Swiper from 'swiper/bundle';
import { initObjectGallerySliders } from './gallery';

jQuery(function ($) {
  if ($('.objects-header-images-slider').length) {
    let objectHeaderImageSlider = new Swiper(".objects-header-images-slider", {
      loop: true,
      effect: "fade",
      watchSlidesProgress: true,
    });

    let objectHeaderContentSlider = new Swiper(".objects-header-content-slider", {
      loop: true,
      effect: "fade",
      autoHeight: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: objectHeaderImageSlider,
      },
    });
  }

  initObjectGallerySliders();

  if ($('.hero-titles-slider').length) {
    const heroSwiper = new Swiper('.hero-titles-slider', {
      direction: 'vertical',
      loop: false,
      allowTouchMove: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: false,
      navigation: false,
      on: {
        reachEnd: function () {
          heroSwiper.autoplay.stop();
        },
        slideChangeTransitionEnd: function () {
          updateHeroSliderHeight();
        },
      },
    });

    updateHeroSliderHeight();
    $(window).on('resize', updateHeroSliderHeight);

    function updateHeroSliderHeight() {
      const activeSlide = $('.hero-titles-slider .swiper-slide-active .hero-title');
      const heroTitleHeight = activeSlide.outerHeight(true);
      $('.hero-titles-slider').height(heroTitleHeight);
    }
  }

  if ($('.team-members').length) {
    const teamsSlider = new Swiper('.team-members', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {
          equalizeTeamSlideHeights('.team-members');
          togglePaginationClass(this.el, '.team-members');
        },
        resize: function () {
          equalizeTeamSlideHeights('.team-members');
          togglePaginationClass(this.el, '.team-members');
        },
      }
    });
  }

  if ($('.testimonial-list').length) {
    const totalSlides   = $('.testimonial-list .swiper-slide').length;
    const swiperOptions = {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
      },
      on: {
        init: function () {
          equalizeTeamSlideHeights('.testimonial-list');
          togglePaginationClass(this.el, '.testimonial-list', 100);
        },
        resize: function () {
          equalizeTeamSlideHeights('.testimonial-list', 125);
          togglePaginationClass(this.el, '.testimonial-list');
        },
      }
    };

    if (totalSlides > 3) {
      swiperOptions.breakpoints[992] = {
        slidesPerView: 3,
      };
    }

    const testimonialSlider = new Swiper('.testimonial-list', swiperOptions);
  }

  function equalizeTeamSlideHeights(containerSelector, bottomPadding = 25) {
    let maxHeight = 0;

    $(`${containerSelector} .swiper-slide`).css('height', 'auto').each(function () {
      const h = $(this).outerHeight() - bottomPadding;
      if (h > maxHeight) maxHeight = h;
    });

    $(`${containerSelector} .swiper-slide`).height(maxHeight);
  }

  function togglePaginationClass(sliderEl, containerSelector) {
    const $container = $(containerSelector);
    const $pagination = $container.find('.swiper-pagination');

    if ($pagination.length && !$pagination.hasClass('swiper-pagination-lock')) {
      $container.addClass('has-pagination');
    } else {
      $container.removeClass('has-pagination');
    }
  }
});
